<template>
  <footer class="main-footer d-print-none">
    <div class="container">
      <div class="row footer-row">
        <div class="col-6">
          <div>
            <span class="footer-heading">{{ $t('footer.title') }}</span>
            <span v-html="$t('footer.description')" />
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <template v-for="link in internal" :key="link.title">
              <router-link class="footer-heading" :to="link.url">
                {{ $t(`footer.menu.${link.title}`) }}
              </router-link>
            </template>
          </div>
          <div class="">
            <template v-for="link in external" :key="link.title">
              <a
                class="footer-heading"
                target="_blank"
                rel="noopener noreferrer"
                :href="$t(`footer.menu.${link.title}Link`)"
              >
                {{ $t(`footer.menu.${link.title}`) }}<span class="external-icn" />
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    internal() {
      return [
        { title: 'contacts', url: { name: `contacts-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } } },
        {
          title: 'termsAndConditions',
          url: { name: `terms-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } },
        },
        { title: 'faq', url: { name: `faq-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } } },
      ];
    },
    external() {
      return [
        { title: 'about' },
        { title: 'paymentTerms' },
        { title: 'privacy' },
        { title: 'cookies' },
      ];
    },
  },
};
</script>
